import React, { useCallback, useEffect } from "react";
import {
  GridLayout,
  GridLayoutItem,
  Stepper,
  StepperChangeEvent,
} from "@progress/kendo-react-layout";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import FITBookingStep1 from "./FITBookingStep1";
import { clearActiveStep, setActiveStep } from "./FITBookingSlice";
import TourItinerary from "./TourItinerary";
import { getAllCities } from "../city/services/city.services";

type ActiveStepProps = {
  step: number;
};

const steps = [
  { label: "Booking Information", isValid: undefined },
  { label: "Booking Itinerary", isValid: undefined },
];

const CreateFITBooking: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const ActiveStep = useAppSelector((state) => state.FITBooking.ActiveStep);

  useEffect(() => {
    dispatch(getAllCities());
    return () => {
      dispatch(clearActiveStep());
    };
  }, []);

  const renderActiveStep = useCallback(
    ({ step }: ActiveStepProps): React.ReactNode => {
      switch (step) {
        case 0:
          return <FITBookingStep1 />;
        case 1:
          return <TourItinerary />;
        default:
          return <FITBookingStep1 />;
      }
    },
    [ActiveStep]
  );

  const handleChange = (e: StepperChangeEvent) => {
    if (location.pathname !== "/fitbooking/create" || e?.value === 0) {
      dispatch(setActiveStep(e.value));
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem
        style={{
          padding: "15px 0",
        }}
      >
        <Stepper value={ActiveStep} onChange={handleChange} items={steps} />
      </GridLayoutItem>
      <GridLayoutItem>{renderActiveStep({ step: ActiveStep })}</GridLayoutItem>
    </GridLayout>
  );
};

export default CreateFITBooking;
